export default __webpack_public_path__ + "static/media/Implantologie_02.e98a2d51.png";